import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, FileText } from 'lucide-react';
const contents = [{
  title: 'The 30-Day Calibration',
  description: "Identify the 'Silent Bombs' in your current diet that are spiking you while you sleep.",
  highlight: 'Silent Bombs'
}, {
  title: "The Operator's Breakfast",
  description: "How to solve the 'Dawn Phenomenon' (high morning sugar) by firing your metabolic engine correctly at 7 AM.",
  highlight: 'Dawn Phenomenon'
}, {
  title: 'The Survival Lunch Guide',
  description: 'How to eat at restaurants and social events without your CGM screaming at you.',
  highlight: ''
}, {
  title: 'The Lockdown Dinner',
  description: "The exact meal-walk combo that ensures your overnight baseline stays flat—the 'secret' to 50% of your A1C score.",
  highlight: 'secret'
}];
export function BlueprintContents() {
  return <section className="w-full py-24 px-4 bg-[#111111]" data-id="element-26">
      <div className="max-w-4xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gray-900/50 border border-gray-800 rounded-2xl p-8 md:p-12" data-id="element-28">
          <div className="flex items-center gap-3 mb-10 border-b border-gray-800 pb-6" data-id="element-29">
            <FileText className="w-8 h-8 text-accent" data-id="element-30" />
            <h2 className="text-2xl md:text-3xl font-bold text-white uppercase tracking-wide" data-id="element-31">
              What’s Inside The Shockproof Blueprint:
            </h2>
          </div>

          <div className="space-y-8" data-id="element-32">
            {contents.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex gap-4 md:gap-6" data-id="element-33">
                <div className="flex-shrink-0 mt-1" data-id="element-34">
                  <CheckCircle2 className="w-6 h-6 text-accent" data-id="element-35" />
                </div>
                <div data-id="element-36">
                  <h3 className="text-lg md:text-xl font-bold text-white mb-2" data-id="element-37">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-38">
                    {item.highlight ? item.description.split(item.highlight).map((part, i, arr) => <span key={i} data-id="element-39">
                              {part}
                              {i < arr.length - 1 && <span className="text-white font-semibold" data-id="element-40">
                                  {item.highlight}
                                </span>}
                            </span>) : item.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}